import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(sdk: Sdk, params: types.GetListParams<client.CalendarUnitEnumSortEnum>) {
  const {
    pagination: { page, perPage },
    sort: { field, order }
  } = params;

  const {
    calendarUnitEnumList: { items: data, total }
  } = await sdk.getListCalendarUnitEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage
    },
    sort: [{ field, order }]
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { calendarUnitEnum: data } = await sdk.getOneCalendarUnitEnum({
    id
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const {
    calendarUnitEnumMany: data
  } = await sdk.getManyCalendarUnitEnum({
    ids
  });

  return {
    data,
  };
}


/*********************************************************************/
export const calendarUnitEnum = types.dataProvider({
  getList,
  getOne,
  getMany
});